import './modules/aosConfig';
import './modules/navigation';
import './modules/howWeWork';